import React from 'react';
import styled from 'styled-components';

import Typography from './Typography';

const MessageBubbleStyled = styled.div<{
  $position: 'relative' | 'absolute';
  $placement?: { top?: string; bottom?: string; left?: string; right?: string };
  $isReceived: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.lightBackground};
  width: 194px;
  border-radius: 20px;
  border-top-left-radius: ${({ $isReceived }) =>
    $isReceived ? '0px' : '20px'};
  border-top-right-radius: ${({ $isReceived }) =>
    $isReceived ? '20px' : '0px'};
  padding: 12px 20px 12px;
  position: ${({ $position }) => $position || 'relative'};
  ${({ $placement }) => ($placement ? $placement : undefined)}
  z-index: 10;

  & .red-dot {
    position: absolute;
    top: 12px;
    right: 12px;
    background-color: red;
    height: 8px;
    width: 8px;
    flex-shrink: 0;

    border-radius: 50%;
  }

  @media (max-width: 500px) {
    width: 130px;
    padding: 6px 8px;
  }
`;

type Props = {
  position?: 'relative' | 'absolute';
  placement?: {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
  };
  isReceived?: boolean;
  message?: string;
};

const MessageBubble = ({
  isReceived = false,
  message = 'HELLO',
  placement,
  position = 'relative',
}: Props) => {
  return (
    <MessageBubbleStyled
      $isReceived={isReceived}
      $placement={placement}
      $position={position}
    >
      <div className="red-dot" />
      <Typography size={12} style={{ lineHeight: '20px' }}>
        {message}
      </Typography>
    </MessageBubbleStyled>
  );
};

export default MessageBubble;
